import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { default as DestroyUserSessionButton } from './DestroyUserSessionButton';

const OnboardingIneligibilityResult = (props) => {
  const {
    ageRange,
    isDtc,
    reason,
  } = props;

  const { t } = useTranslation();
  const [minAge, maxAge] = ageRange ? ageRange.split('..').map((n) => parseInt(n, 10)) : [];

  return (
    <div className='test-result__container test-result__container--wide'>
      <div
        className={`
          test-result__cols
          ${isDtc ? '' : 'test-result__cols--center'}
        `}
      >
        <div className='test-result__col test-result__your-results-container'>
          <header className='test-result__header'>
            <h1 className='viz-text viz-text--xxl viz-text--bold test-result__heading branded__heading branded__heading--primary'>
              {
                t('OnboardingIneligibilityResult.heading')
              }
            </h1>
          </header>
          <section className='test-result__dq-reason-container'>
            <p className='viz-text viz-text--lg test-result__copy'>
              {
                t(`OnboardingIneligibilityResult.${reason}.copy`, { minAge, maxAge })
              }
            </p>
          </section>
          {
            !isDtc &&
              <footer className='test-result__footer'>
                <DestroyUserSessionButton />
              </footer>
          }
        </div>

        {
          isDtc &&
            <div className='test-result__col test-result__next-steps-container'>
              <div className='test-result__next-steps-card'>
                <header className='test-result__header'>
                  <h1 className='viz-text viz-text--xxl viz-text--bold test-result__heading branded__heading branded__heading--primary'>
                    {
                      t('OnboardingIneligibilityResult.cta.heading')
                    }
                  </h1>
                </header>

                <p className='viz-text viz-text--lg test-result__copy'>
                  {
                    t('OnboardingIneligibilityResult.cta.copy')
                  }
                </p>

                <a
                  href='/find_a_doctor'
                  className='
                    test-result__button
                    test-result__button--doc
                    viz-btn
                    viz-btn--primary
                  '
                >
                  {
                    t('OnboardingIneligibilityResult.cta.button')
                  }
                </a>
              </div>
            </div>
        }
      </div>
    </div>
  );
};

OnboardingIneligibilityResult.propTypes = {
  ageRange: PropTypes.string,
  isDtc: PropTypes.bool,
  reason: PropTypes.string.isRequired,
};

OnboardingIneligibilityResult.defaultProps = {
  ageRange: '',
  isDtc: true,
};

export default OnboardingIneligibilityResult;
